import configurationApi from '../../api/configuration'

const state = {
    emailDomains: [],
}

const getters = {
    emailDomains: state => state.emailDomains,
}

const mutations = {
    setEmailDomains (state, emailDomains) {
        state.emailDomains = emailDomains
    },
}

const actions = {
    getEmailDomains ({ commit }) {
        const emailDomains = configurationApi.getEmailDomains().then(res => {
            commit('setEmailDomains', res.data)
        })
        return emailDomains
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}